module.exports = __webpack_public_path__ + "static/media/appcenter-redefinePassword.673b182b.svg";